module.exports = __webpack_public_path__ + "static/laptop-cf91aab23f2f9d338364926d6486b7c9.png";